import { render, staticRenderFns } from "./layouts.auth-split.1f5d30a2.vue?vue&type=template&id=6a983307"
import script from "./layouts.auth-split.1f5d30a2.vue?vue&type=script&lang=js"
export * from "./layouts.auth-split.1f5d30a2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports